import { useEffect, useRef, useState } from 'react';
import './toast.css';

const TOAST_EVENT = 'app:toast';
const TOAST_DURATION = 3200;

export const showToast = ({ title, description } = {}) => {
    if (typeof window === 'undefined')
        return;

    window.dispatchEvent(new CustomEvent(TOAST_EVENT, {
        detail: { title, description }
    }));
};

export const Toast = () => {
    const [toasts, setToasts] = useState([]);
    const timers = useRef(new Map());

    useEffect(() => {
        const removeToast = (id) => {
            const timer = timers.current.get(id);
            if (timer)
                clearTimeout(timer);
            timers.current.delete(id);
            setToasts((current) => current.filter((toast) => toast.id !== id));
        };

        const handleToast = (event) => {
            const id = `${Date.now()}-${Math.random()}`;
            const toast = { ...event.detail, id };
            setToasts((current) => [...current.slice(-2), toast]);
            timers.current.set(id, setTimeout(() => removeToast(id), TOAST_DURATION));
        };

        window.addEventListener(TOAST_EVENT, handleToast);
        return () => {
            window.removeEventListener(TOAST_EVENT, handleToast);
            timers.current.forEach(clearTimeout);
            timers.current.clear();
        };
    }, []);

    if (!toasts.length)
        return null;

    return (
        <div className="app-toast-stack" role="status" aria-live="polite" aria-atomic="false">
            {toasts.map((toast) => (
                <div className="app-toast" key={toast.id}>
                    <span className="app-toast-icon" aria-hidden="true">
                        <svg viewBox="0 0 24 24">
                            <path d="m6 12.5 4 4L18.5 8" />
                        </svg>
                    </span>
                    <span className="app-toast-content">
                        {toast.title && <strong>{toast.title}</strong>}
                        {toast.description && <span>{toast.description}</span>}
                    </span>
                    <button
                        className="app-toast-close"
                        type="button"
                        aria-label="Закрыть уведомление"
                        onClick={() => {
                            const timer = timers.current.get(toast.id);
                            if (timer)
                                clearTimeout(timer);
                            timers.current.delete(toast.id);
                            setToasts((current) => current.filter((item) => item.id !== toast.id));
                        }}
                    >
                        ×
                    </button>
                </div>
            ))}
        </div>
    );
};
